import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  fonts: {
    heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
    body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
  },
  styles: {
    global: {
      body: {
        bg: "#0a0a0a",
        color: "white",
      },
    },
  },
  colors: {
    gray: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#c8c8d4",
      500: "#a0a0b0",
      600: "#75758a",
      700: "#27272a",
      750: "#1f1f23",
      800: "#18181b",
      850: "#121214",
      900: "#09090b",
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "500",
        borderRadius: "lg",
      },
      variants: {
        // Azione principale - bianco
        primary: {
          bg: "white",
          color: "gray.900",
          _hover: { bg: "gray.200" },
          _active: { bg: "gray.300" },
        },
        // Azione distruttiva - rosso pieno
        danger: {
          bg: "red.600",
          color: "white",
          _hover: { bg: "red.500" },
          _active: { bg: "red.400" },
        },
        // Elimina ghost - testo rosso
        "danger-text": {
          color: "red.400",
          _hover: { bg: "red.900" },
        },
        // Default solid
        solid: {
          bg: "gray.700",
          color: "white",
          _hover: { bg: "gray.600" },
        },
        ghost: {
          color: "gray.300",
          _hover: { bg: "gray.800" },
        },
        outline: {
          borderColor: "gray.600",
          color: "gray.300",
          _hover: { bg: "gray.800" },
        },
      },
    },
    IconButton: {
      variants: {
        // Pulsante attivo (es. editor toolbar)
        primary: {
          bg: "white",
          color: "gray.900",
          _hover: { bg: "gray.200" },
        },
        // Ghost con colore per icone azione
        action: {
          color: "gray.400",
          _hover: { color: "white", bg: "transparent" },
        },
        // Ghost rosso per delete
        "danger-ghost": {
          color: "red.400",
          _hover: { color: "red.300", bg: "transparent" },
        },
      },
    },
    Badge: {
      baseStyle: {
        borderRadius: "md",
        px: 2,
        py: 0.5,
      },
      variants: {
        // Badge neutro
        subtle: {
          bg: "gray.700",
          color: "gray.300",
        },
        // Badge numerato (posizione lista)
        number: {
          bg: "gray.600",
          color: "white",
        },
        // Badge stato annullato
        cancelled: {
          bg: "red.900",
          color: "red.300",
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: "gray.850",
          borderColor: "gray.700",
          borderWidth: "1px",
          borderRadius: "xl",
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          bg: "gray.850",
          borderColor: "gray.700",
          borderWidth: "1px",
        },
      },
    },
    Input: {
      variants: {
        filled: {
          field: {
            bg: "gray.800",
            borderColor: "gray.700",
            _hover: { bg: "gray.750" },
            _focus: { bg: "gray.800", borderColor: "gray.500" },
          },
        },
      },
      defaultProps: {
        variant: "filled",
      },
    },
    Checkbox: {
      defaultProps: {
        colorScheme: "gray",
      },
    },
    Progress: {
      baseStyle: {
        track: { bg: "gray.700" },
      },
      defaultProps: {
        colorScheme: "gray",
      },
    },
    Tabs: {
      variants: {
        enclosed: {
          tab: {
            color: "gray.400",
            _selected: { color: "white", bg: "gray.700" },
          },
        },
      },
    },
  },
});

export default theme;
